import { NavLink } from 'react-router-dom'
import { useState, useEffect } from 'react'
import {
  LayoutDashboard,
  CheckSquare,
  MessageSquare,
  FileText,
  ClipboardList,
  Boxes,
  Users,
  BarChart3,
  Bell,
} from 'lucide-react'
import { cn } from '@/lib/utils/cn'
import { Badge } from '@/components/ui/badge'
import { useAuth } from '@/hooks/useAuth'
import { messageService } from '@/services'

const navigation = [
  { name: 'Home', href: '/', icon: LayoutDashboard },
  { name: 'Workspaces', href: '/workspaces', icon: Boxes },
  { name: 'Projects', href: '/projects', icon: ClipboardList },
  { name: 'Tasks', href: '/tasks', icon: CheckSquare },
  { name: 'Messages', href: '/messages', icon: MessageSquare },
  { name: 'Documents', href: '/documents', icon: FileText },
  { name: 'Users', href: '/users', icon: Users },
  { name: 'Reports', href: '/reports', icon: BarChart3 },
  { name: 'Inbox', href: '/inbox', icon: Bell },
]

export function Sidebar() {
  const { user } = useAuth()
  const [unreadCount, setUnreadCount] = useState(0)

  useEffect(() => {
    const loadUnreadCount = async () => {
      if (!user) return
      try {
        const unreadMessages = await messageService.getUnreadMessages(user.id)
        setUnreadCount(unreadMessages.length)
      } catch (error) {
        console.error('Failed to load unread message count:', error)
      }
    }

    loadUnreadCount()
    // Refresh count every 30 seconds
    const interval = setInterval(loadUnreadCount, 30000)
    return () => clearInterval(interval)
  }, [user])

  return (
    <aside className="hidden lg:flex flex-col w-64 border-r border-r-gray-200 bg-gray-50 dark:bg-gray-900 dark:border-r-gray-700">
      <nav className="flex-1 space-y-2 p-4">
        {navigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            end={item.href === '/'}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded-lg px-3 py-2 text-md font-medium transition-colors',
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground'
              )
            }
          >
            <item.icon className="h-5 w-5" />
            {item.name}
            {item.name === 'Messages' && unreadCount > 0 && (
              <Badge
                variant="destructive"
                className="ml-auto h-5 w-5 flex items-center justify-center p-0 text-xs"
              >
                {unreadCount > 99 ? '99+' : unreadCount}
              </Badge>
            )}
          </NavLink>
        ))}
      </nav>
    </aside>
  )
}
